export { default as AddToCart } from './addToCart/AddToCart';
